import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { REVERB } from "./constants";

// @ts-ignore
window.Pusher = Pusher;

let localData = localStorage.getItem("w_token");
const token = localData ? JSON.parse(localStorage.getItem("w_token") || "") : '';

const echo = new Echo({
    broadcaster: 'reverb',
    // key: '1jaizexptjb5kmcpsfod', 
    // wsHost: `74win.in`,//window.location.hostname,
    // wsPort: 2096,
    // wssPort: 2096,
    key: REVERB.REVERB_APP_KEY, 
    wsHost: REVERB.REVERB_HOST,//window.location.hostname,
    wsPort: REVERB.REVERB_PORT,
    wssPort: REVERB.REVERB_PORT,
    forceTLS: true,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    // authEndpoint: 'https://74win.in/74win/broadcasting/auth',
    // auth: {
    //     headers: {
    //         Authorization: `Bearer ${token?.access_token}`,  // Replace with your actual token
    //         Accept: 'application/json',
    //     },
    // },
});

export default echo;
